import { useState } from "react";
import {
  EMAIL_MAX_LENGTH,
  INITIAL_TICKET_FORM,
  NAME_MAX_LENGTH,
  PHONE_MAX_LENGTH,
} from "./ticketFormConfig";
import { getFieldInputError } from "./ticketFormHelpers";

// The "פתיחת קריאה" form fields, their validation errors and change handlers
export const useTicketForm = () => {
  const [formData, setFormData] = useState(INITIAL_TICKET_FORM);
  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  // Keeps the typed value only when it's allowed, otherwise shows why under the field
  const handleValidatedChange = (field, label, maxLength, allowed) => (event) => {
    const value = event.target.value;
    const error = getFieldInputError(value, label, maxLength, allowed);
    if (error) {
      setFieldErrors((prev) => ({ ...prev, [field]: error }));
      return;
    }
    setFormData({
      ...formData,
      [field]: value,
    });
    setFieldErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleCheckboxChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.checked,
    });
  };

  return {
    formData, setFormData, fieldErrors, handleChange, handleCheckboxChange,
    handleNameChange: (field, label) => handleValidatedChange(field, label, NAME_MAX_LENGTH, "letters"),
    handlePhoneChange: handleValidatedChange("phone", "טלפון", PHONE_MAX_LENGTH, "digits"),
    handleEmailChange: handleValidatedChange("email", "אימייל", EMAIL_MAX_LENGTH),
  };
};
